import React, { Component } from 'react'
import debounce from 'lodash/debounce'
import get from 'lodash/get'

import beautifyJS from 'js-beautify'

import CodeMirror from 'codemirror/lib/codemirror'
import 'codemirror/addon/selection/active-line'
import 'codemirror/addon/edit/closetag'
import 'codemirror/addon/edit/matchtags'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/search/match-highlighter'
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/jump-to-line'
import 'codemirror/addon/dialog/dialog'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/matchesonscrollbar'
import 'codemirror/addon/hint/show-hint'
import 'codemirror/addon/hint/xml-hint'
import 'codemirror/mode/xml/xml'
import 'codemirror/addon/lint/lint'

import './helpers/codemirror-util-autoformat'

import {
  completeAfter,
  completeIfAfterLt,
  completeIfInTag,
} from './helpers/codemirror-autocomplete-mjml'

import { completeAfterSnippet } from './helpers/codemirror-autocomplete-snippets'

import './styles/styles.less'
import './styles/CodeEditor.less'

function beautify(content) {
  return beautifyJS.html(content, {
    indent_size: 2, // eslint-disable-line camelcase
    wrap_attributes_indent_size: 2, // eslint-disable-line camelcase
  })
}

class FileEditor extends Component {

  componentWillMount() {
    // used to store different histories, for ability to restore
    // it when switching to another file then switching back
    this._historyCache = {}
  }

  componentDidMount() {
    this.initEditor()
  }
  
  componentDidUpdate() {
    const { value, name, mode } = this.props

    if (mode === 'html' && name === 'htmlPreview' && this._codeMirror) {
      this._codeMirror.setValue(value)
    }
  }

  componentWillUnmount() {
    if (this._codeMirror) {
      this._codeMirror.toTextArea()
      this._codeMirror = null
    }
  }

  initEditor() {
    if (!this._textarea) {
      return
    }

    const { value, onChange, readOnly = false } = this.props

    if (this._codeMirror) {
      this._codeMirror.toTextArea()
      this._codeMirror = null
    }

    this._codeMirror = CodeMirror.fromTextArea(this._textarea, {
      readOnly,
      theme: 'material',
      tabSize: 2,
      lineWrapping: true,
      dragDrop: false,
      mode: 'xml',
      lineNumbers: true,
      autoCloseTags: true,
      foldGutter: true,
      gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
      styleActiveLine: {
        nonEmpty: true,
      },
      highlightSelectionMatches: {
        wordsOnly: true,
      },
      extraKeys: {
        /* eslint-disable quotes */
        "'<'": (cm, pred) => completeAfter(CodeMirror, cm, pred),
        "'/'": cm => completeIfAfterLt(CodeMirror, cm),
        "' '": cm => completeIfInTag(CodeMirror, cm),
        "'='": cm => completeIfInTag(CodeMirror, cm),
        'Ctrl-Space': 'autocomplete',
        /* eslint-enable quotes */
      },
      lint: this.handleValidate,
    })

    this._codeMirror.setValue(value)

    if (onChange) this._codeMirror.on('change', onChange)
  }

  handleValidate = () => {
    const { errors = [] } = this.props

    return errors.map(err => ({
      message: err.message,
      severity: 'error',
      from: CodeMirror.Pos(err.line - 1, 1),
      to: CodeMirror.Pos(err.line - 1, 1),
    }))
  }

  getContent = () => {
    return this._codeMirror.getValue()
  }

  setContent = content => {
    const scrollInfo = this._codeMirror.getScrollInfo()
    this._codeMirror.setValue(content)
    this._codeMirror.scrollTo(0, scrollInfo.top)
  }

  beautify = () => {
    const value = this.getContent()
    const beautified = beautify(value)
    this.setContent(beautified)
  }

  render() {
    return (
      <div
        className="FileEditor CodeEditor"
        style={{
          height: '100%',
        }}
      >
        <textarea ref={r => (this._textarea = r)} />
      </div>
    )
  }
}

export default FileEditor
